import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import WorkersByGroupChartCard from 'components/common/WorkersByGroupChartCard';

const WorkersSection = ({ cropsAnalyticsData, workdayData, previousDate }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <WorkersByGroupChartCard
        data={cropsAnalyticsData.workersByGroupYesterday}
        totalWorkers={workdayData.totalWorkers}
        title={t('dashboard.workersByGroupYesterday')}
        cardColor="green"
        currentDate={previousDate}
      />
      <WorkersByGroupChartCard
        data={workdayData.workersByGroup}
        totalWorkers={workdayData.totalWorkers}
        title={t('dashboard.workersByGroupToday')}
        cardColor="green"
        currentDate={workdayData.currentDate}
      />
    </div>
  );
};

WorkersSection.propTypes = {
  cropsAnalyticsData: PropTypes.shape({
    workersByGroupYesterday: PropTypes.arrayOf(PropTypes.object)
  }),
  workdayData: PropTypes.shape({
    totalWorkers: PropTypes.number,
    workersByGroup: PropTypes.arrayOf(PropTypes.object),
    currentDate: PropTypes.string
  }),
  previousDate: PropTypes.string
};

export default WorkersSection;
